<template>
  <div>
    <ThePageHeader :title="'Rólunk'" />

    <div class="text">
      <p>
        A Körös Print-Pack Kft. 1989-ben alakult, a mai napig teljes mértékben magyar tulajdonosi
        háttérrel rendelkezik. Az évek során folyamatos fejlesztéseket hajtottunk végre,
        gépberuházásaink eredményeként mind jobb minőségben tudtuk a ránk bízott munkákat elvégezni,
        egyre szélesedett az ügyfélkörünk. Szoros kapcsolatot ápolunk vevőinkkel, akik nagyra
        értékelik az ügyfélközpontú kiszolgálást, a minőségi termékeket valamint a határidők pontos
        betartását.
      </p>

      <p>
        Fő tevékenységi körünkbe tartozik az íves csomagolóeszköz gyártása, ezen belül is a magas
        minőségigényű doboz- és címkegyártás. A kis és közepes példányszámú nyomdatermékek gyártása
        mellett már a nagyobb szériák szállítására is berendezkedtünk, mindemellett továbbra is
        rugalmasan tudunk reagálni a vevők igényeire.
      </p>
    </div>

    <VLayout
      wrap
      justify-space-around
      class="white--text mt-5 maximize"
      style="width: 1000px; max-width: 95%;"
    >
      <VFlex xs12 sm4>
        <a href="/img/certificates/BRC.jpg" target="_blank">
          <img src="/img/certificates/BRC.jpg" style="width: 100%;" />
        </a>
      </VFlex>

      <VFlex class="px-2" xs12 sm4>
        <a href="/img/certificates/ISO9001.jpg" target="_blank">
          <img src="/img/certificates/ISO9001.jpg" style="width: 100%;" />
        </a>
      </VFlex>

      <VFlex xs12 sm4>
        <a href="/img/certificates/ISO14001.jpg" target="_blank">
          <img src="/img/certificates/ISO14001.jpg" style="width: 100%;" />
        </a>
      </VFlex>

      <VFlex xs12 sm4>
        <a href="/img/certificates/FSC.jpg" target="_blank">
          <img src="/img/certificates/FSC.jpg" style="width: 100%;" />
        </a>
      </VFlex>

      <VFlex xs12 sm8>
        <a href="/img/certificates/green.jpg" target="_blank">
          <img src="/img/certificates/green.jpg" style="width: 100%;" />
        </a>
      </VFlex>
    </VLayout>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'About',
  metaInfo: {
    title: 'Rólunk | Körös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: '',
      },
    ],
  },
  components: {
    ThePageHeader,
  },
};
</script>

<style scoped>
.text {
  margin: 100px auto 0 auto;
  width: 1000px;
  max-width: 90vw;
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
}
</style>
